import { render, staticRenderFns } from "./FIBDate.vue?vue&type=template&id=5db3db86&scoped=true&"
import script from "./FIBDate.vue?vue&type=script&lang=js&"
export * from "./FIBDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db3db86",
  null
  
)

export default component.exports
import QDate from 'quasar/src/components/date/QDate.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDate});
